<template>
  <div>
    <div
      v-if="isHeader1"
      :style="{ color: color === '' ? 'inherit' : color }"
      :class="{
        'text-uppercase': isUppercaseActive,
        'asc-header--no-margins': isNoMargins,
        'asc-header--h1': true,
        'asc-header--active': isActive,
      }"
    >
      {{ value }}
    </div>
    <div
      v-if="isHeader2"
      :style="{ color: color === '' ? 'inherit' : color }"
      :class="{
        'text-uppercase': isUppercaseActive,
        'asc-header--no-margins': isNoMargins,
        'asc-header--h2': true,
        'asc-header--active': isActive,
      }"
    >
      {{ value }}
    </div>
    <div
      v-if="isHeader3"
      :style="{ color: color === '' ? 'inherit' : color }"
      :class="{
        'text-uppercase': isUppercaseActive,
        'asc-header--no-margins': isNoMargins,
        'asc-header--h3': true,
        'asc-header--active': isActive,
      }"
    >
      {{ value }}
    </div>
    <div
      v-if="isHeader4"
      :style="{ color: color === '' ? 'inherit' : color }"
      :class="{
        'text-uppercase': isUppercaseActive,
        'asc-header--no-margins': isNoMargins,
        'asc-header--h4': true,
        'asc-header--active': isActive,
      }"
    >
      {{ value }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'AscHeader',

  props: {
    uppercase: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'h1',
      validator: val => ['h1', 'h2', 'h3', 'h4'].includes(val),
    },
    value: {
      type: [String, Number],
      required: true,
    },
    noMargins: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: '',
    },
  },

  computed: {
    isHeader1() {
      return this.size === 'h1'
    },
    isHeader2() {
      return this.size === 'h2'
    },
    isHeader3() {
      return this.size === 'h3'
    },
    isHeader4() {
      return this.size === 'h4'
    },
    isUppercaseActive() {
      return this.uppercase
    },
    isNoMargins() {
      return this.noMargins
    },
  },
}
</script>

<style lang="scss">
.asc-header--h1,
.asc-header--h2,
.asc-header--h3,
.asc-header--h4 {
  color: $gray-1000;
  font-family: inherit;
  letter-spacing: 0;
  font-weight: 400;
}

.asc-header--h1 {
  font-size: $font-size-h1;
}

.asc-header--h2 {
  font-size: $font-size-h2;
}

.asc-header--h3 {
  font-size: $font-size-h3;
}

.asc-header--h4 {
  font-size: $font-size-h4;
}

.asc-header--no-margins {
  margin-top: 0;
  margin-bottom: 0;
}

.asc-header--active {
  color: $accent-700 !important;
}
</style>
